// extracted by mini-css-extract-plugin
export default {"graphContainer":"BoxPlotGraph_graphContainer__0KFMK"};